import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../actions/standalone';
import {
  selectPhotoGroupsHasPhoto,
  selectPhotosList,
} from '../../actions/selector';
import { map, switchMap } from 'rxjs/operators';

@Pipe({
    name: 'namePhotoGroup',
    standalone: false
})
export class NamePhotoGroupPipe implements PipeTransform {
  photosList$ = this.store.pipe(select(selectPhotosList));
  photoGroups$ = this.store.pipe(select(selectPhotoGroupsHasPhoto));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(photoGroupId: string) {
    return this.photoGroups$.pipe(
      map((value) => ({
        photoId: value.find((value1) => value1.photoGroupId === photoGroupId)
          ?.photoId,
      })),
      switchMap(({ photoId }) =>
        this.photosList$.pipe(
          map((value) => ({
            name: value.find((value1) =>
              value1.photos.find((value2) => value2.photoId === photoId)
            )?.name,
          }))
        )
      ),
      map(({ name }) => {
        return name;
      })
    );
  }
}
